export default __webpack_public_path__ + "static/cholesterol-lipids-box@2x-b1ac32265248a420853de0865195f645.png";